import React from 'react';
import { colors } from '@chegg-ui/theme';
import { DeleteIcon } from '@chegg-ui/horizon-icons';
import { DeleteAnnotationButton, TextArea, Wrapper } from './styled';
import { TestIds } from './constants';
import { useFormikContext } from 'formik';
export var AnnotationArea = function AnnotationArea(_ref) {
  var handleClose = _ref.handleClose;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TextArea, {
    name: "annotation",
    inputId: "annotation-textarea",
    labelText: "Annotation",
    "data-test": TestIds.TEXTAREA
  }), /*#__PURE__*/React.createElement(DeleteAnnotationButton, {
    size: 'small',
    onClick: function onClick() {
      setFieldValue('annotation', '');
      handleClose();
    },
    "data-test": TestIds.DELETE_ICON_BUTTON,
    screenReaderOnlyText: "delete annotation"
  }, /*#__PURE__*/React.createElement(DeleteIcon, {
    size: "small",
    svgColor: colors.dark
  })));
};